/* Add to Cart color cycle (Hagan 2026-10-19): on a product page, once the
   Add to Cart button has been on screen for 3 seconds it starts the same
   slow stroll through the brand palette as the menu's Shop All Toys pill
   (glo-brand.css .gp-atc-party). Scrolling it away stops it and re-arms
   the 3 seconds. Product pages only - not the quick-buy drawer - and never
   on a sold-out button or with reduced motion. Family swaps replace the
   button, so new buttons are picked up as they land. */

(function () {
  if (!('IntersectionObserver' in window)) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var timers = new WeakMap();

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var btn = e.target;
      var surf = btn.querySelector('.push-btn__surface');
      if (!surf) return;
      if (e.isIntersecting && !reduce.matches) {
        if (timers.has(btn) || surf.classList.contains('gp-atc-party')) return;
        timers.set(btn, setTimeout(function () {
          timers.delete(btn);
          if (btn.disabled || !btn.classList.contains('push-btn')) return; // sold out
          // the loop starts and ends at the button's own resting colors
          var cs = getComputedStyle(surf);
          surf.style.setProperty('--gp-atc-rest-bg', cs.backgroundColor);
          surf.style.setProperty('--gp-atc-rest-fg', cs.color);
          surf.classList.add('gp-atc-party');
        }, 3000));
      } else {
        clearTimeout(timers.get(btn));
        timers.delete(btn);
        surf.classList.remove('gp-atc-party');
      }
    });
  }, { threshold: 0.6 });

  function scan() {
    document.querySelectorAll('.shopify-section .product-block-buy-buttons .add-to-cart-btn').forEach(function (b) {
      if (b.__gpParty || b.closest('[data-might-be-empty]')) return;
      b.__gpParty = true;
      io.observe(b);
    });
  }

  var t = null;
  function start() {
    scan();
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(scan, 200);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
